import ComingSoon from "@/components/ComingSoon";

export default function ComplianceBenchmarksPage() {
  return <ComingSoon featureName="Compliance Benchmarks" description="CIS benchmark rules, compliance scores, and security assessments. This feature requires backend Compliance APIs." />;
}
